import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button, Col, Form, Row,
} from 'react-bootstrap';
import {
  FormCheck,
  Headline,
  scrollToError,
  trEnv,
  savedStateManager,
  appActions,
  BeantragenWiderrufsbelehrung,
  SummingUp,
  CaptchaFormInput,
  SpeicherButton,
  PrevNextButton, useNextPage,
  actions,
} from 'ion-lib';
import i18next from 'i18next';
import WarenkorbInhalt from '../../components/WarenkorbInhalt';
import { getBannerFileName } from '../../helper';
import SummingupWarenkorb from '../../components/SummingupWarenkorb';

const Beantragen = () => {
  const [nichtgeladenError, setNichtgeladenError] = useState(false);
  const [nichtzugestimmtError, setNichtzugestimmtError] = useState(false);
  const nextPage = useNextPage();
  const beratungsdok = useSelector((state) => state.appDaten.dokumente.beratung);
  const dokumenteGeladen = useSelector((state) => state.appDaten.dokumente.geladen);
  const nachname = useSelector((state) => state.daten.vn.nachname);

  const dispatch = useDispatch();

  const validateCaptcha = () => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'captchaText',
    ]));
  };

  const getBeratungDok = () => {
    dispatch(appActions.pdfRequest('holeDokumente', `Antragsdokumente_${nachname.value}.pdf`, () => {
      dispatch(actions.updateByName('appDaten.dokumente.beratung', true));
      setNichtgeladenError(false);
    }));
  };

  const check = (e) => {
    if (!beratungsdok) {
      setNichtgeladenError(true);
      scrollToError();
      return;
    }

    dispatch(actions.updateByEvent(e, () => {
      setNichtzugestimmtError(false);
    }));
  };

  const beantragen = () => {
    if (!beratungsdok) {
      setNichtgeladenError(true);
      scrollToError();
      return;
    }
    if (!dokumenteGeladen) {
      setNichtzugestimmtError(true);
      scrollToError();
      return;
    }
    dispatch(appActions.serverValidationRequest('validiere', [
      'captchaText',
    ], () => {
      dispatch(appActions.request('beantragen', () => {
        if (trEnv.sparkasse) {
          dispatch(appActions.request(
            'beendeTarifrechner',
            () => {
              window.OSPlusNeo.reportSuccess();
            },
            () => {
              window.OSPlusNeo.reportError();
            },
          ));
          return;
        }

        savedStateManager.deleteFromLocalStorage();
        savedStateManager.deleteFromSessionStorage();
        nextPage();
      }));
    }));
  };

  return (
    <Row>
      <Col>
        <div className="w-md spkpanel">
          <Headline>Beantragen</Headline>
          <div>
            <h2 className="h5">
              1. Klicken Sie auf den Button, um Ihre
              {' '}
              <Button
                variant="link"
                className="fw-normal"
                data-tracking-name="modal-downloadinhalt"
                onClick={() => dispatch(appActions.toggleModal(
                  i18next.t('beantragen.downloadinhalt'),
                ))}
              >
                Dokumente
              </Button>
              {' '}
              herunterzuladen:
            </h2>

            <Form.Group className="form-group mb-4">
              <Button
                onClick={getBeratungDok}
                data-tracking-name="button-wichtige-dokumente-herunterladen"
              >
                Jetzt wichtige Dokumente und Informationen herunterladen
              </Button>
              {nichtgeladenError && <Form.Control.Feedback className="sp-w-100" type="invalid">Bitte laden Sie die wichtigen Dokumente und Informationen herunter.</Form.Control.Feedback>}
            </Form.Group>
          </div>
          <div className="mt-5">
            <h2 className="h5">2. Klicken Sie hier auf den Button, um den Download zu bestätigen:</h2>

            <FormCheck
              ueberschreibbar
              relevant
              value={dokumenteGeladen}
              name="appDaten.dokumente.geladen"
              title={'Ich bestätige, dass ich die wichtigen Dokumente und Informationen sowie'
                + ' die Übersicht der Antragsdaten heruntergeladen, gedruckt bzw. gespeichert und zur Kenntnis genommen habe.'}
              onChange={check}
              className={`fw-light checkbox-button sp-child-w-100 ${!beratungsdok ? 'disabled' : ''}`}
              error={nichtzugestimmtError ? 'Bitte bestätigen Sie, dass Sie die Dokumente und'
                  + ' Informationen erhalten haben.' : null}
            />
          </div>

          <BeantragenWiderrufsbelehrung />

          <WarenkorbInhalt />

          <CaptchaFormInput
            validateCaptcha={validateCaptcha}
            tooltip={() => dispatch(appActions.toggleModal(i18next.t('beantragen.captcha_tt')))}
          />

          <Button
            className={`mt-4 ${!beratungsdok || !dokumenteGeladen ? 'disabled' : ''}`}
            data-tracking-name="button-beantragen"
            onClick={beantragen}
          >
            Jetzt verbindlich beantragen
          </Button>
        </div>

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
            />
            <SpeicherButton />
          </Col>
        </Row>
      </Col>

      <SummingUp bannerImg={getBannerFileName}>
        <SummingupWarenkorb />
      </SummingUp>
    </Row>
  );
};

export default Beantragen;
